import { PickNChooseHeader } from '@intigral/shared';
import f from '../../../helpers/formatter';
import { __ } from '../../../translations';
import { IComponentHeaderProps } from '../types/iPickAndChooseHeader';
import { useBundleAndSaveRules } from '../hooks/useBundleAndSaveRules';

const BundleAndSaveHeader: React.FC<IComponentHeaderProps> = ({ carousel, meta }) => {
    const { data: bundleAndSaveRules } = useBundleAndSaveRules() || {};
    const discountRules = bundleAndSaveRules?.data?.discountRules;

    if (!discountRules?.length) {
        return null;
    }

    return (
        <div id={carousel?.id} data-test-id={carousel?.id}>
            <PickNChooseHeader
                heading={f.getComponentTitle(meta)}
                description={discountRules?.reverse()?.map((rule) => {
                    return __('bundle_and_save_header_info', {
                        noOfAddons: rule?.minNoOfAddons,
                        discountPercentage: `${rule?.discountPercentage}%`,
                    });
                })}
            />
        </div>
    );
};

export default BundleAndSaveHeader;
